import detectors from '../../../../tv24/js/es6/detectors/detectOs';

export default class LinksTooltip {

    constructor() {
        if(detectors.isMobile()){
            return;
        }
        this.linksForTooltip = $('a.more-link[data-name][data-photosrc]');
        if($(this.linksForTooltip).length === 0){
            return;
        }

        this.initTooltips(this.linksForTooltip);
    };

    initTooltips(links) {
        $(links).hover(function () {
            let a = $(this);
            if(!hasTooltip(a)) {
                buildTooltip(a);
            }

            let halfHeight = $(window).height() / 2;
            if ($(a).offset().top - $(window).scrollTop() < halfHeight) {
                $('.moreLinkDescr').addClass('moreLinkDescrBottom');
            } else {
                $('.moreLinkDescr').removeClass('moreLinkDescrBottom');
            }

            let fullWidth = $('#newsSummary').width();
            let halfWidth = fullWidth / 2;
            let rightPosition = fullWidth - ($(a).position().left + $(a).width());

            if (rightPosition < halfWidth) {
                $(a).find('.moreLinkDescr').addClass('moreLinkDescrLeft');
            } else {
                $(a).find('.moreLinkDescr').removeClass('moreLinkDescrLeft');
            }
        });

        var hasTooltip = function (a){
            return $(a).children("span.moreLinkDescr").length > 0;
        };

        function buildTooltip(a) {
            let name = $(a).attr('data-name');
            let photoSrc = $(a).attr('data-photosrc');

            let tooltip =
                `<span class="moreLinkDescr">
                    <span class="moreLinkDescrWrap">
                        <img src="${photoSrc}">
                        <span>${name}</span>
                    </span>
                 </span>`;
            $(a).append(tooltip);
        }
    }
}